export class WorkPlace {
  public id: number;
  public name: string;
  public roomName: string;

  public constructor(init?: Partial<WorkPlace>) {
    Object.assign(this, init);
  }
}
